import { z } from 'zod';

export const deleteImgResponseSchema = z.object({
  accepted: z.boolean(),
  deletedRows: z.number(),
  deletedR2Keys: z.number(),
});

export type IDeleteImgResponse = z.infer<typeof deleteImgResponseSchema>;
